import React from "react";
import "./Contct.css";


function Contact() {
  return (
    <div>
      <div className="row banner">
        <div className="bannerinside">
          <div className="headtitle">
            <div className="title-icon">
              <span className="icon-ring">
                <img src="./images/shiva.png" alt="Darshan" />
              </span>
            </div>

            <div className="title-content">
              <span className="title-small">TEMPLE</span>
              <h2 className="texthead">Contact</h2>

              <div className="title-divider">
                <span></span>
                <i>✦</i>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container" style={{ marginTop: '100px', marginBottom: '100px' }}>

        <div className="contact-location-section">

  <div className="contact-location-container">

    {/* LEFT - CONTACT DETAILS */}
    <div className="contact-details">

      <div className="contact-heading">

        <span className="contact-eyebrow">
          GET IN TOUCH
        </span>

        <h2>
          Contact <span>Us</span>
        </h2>

        {/* <p>
          For enquiries, assistance and official communication,
          please contact the temple office.
        </p> */}

      </div>


      {/* Address */}
      <div className="contact-info-card">

        <div className="contact-info-icon">
          <i className="fa fa-map-marker"></i>
        </div>

        <div className="contact-info-content">

          <span>OFFICE ADDRESS</span>

          <p>
            <strong>The Executive Officer</strong>
            <br />
           Azhimala Siva Temple
           
            <br />
            Thiruvananthapuram – .
          </p>

        </div>

      </div>


      {/* Phone */}
      <div className="contact-info-card">

        <div className="contact-info-icon">
          <i className="fa fa-phone"></i>
        </div>

        <div className="contact-info-content">

          <span>PHONE</span>

          <a href="tel:04712450233">
            999999999
          </a>

        </div>

      </div>


      {/* Email */}
      <div className="contact-info-card">

        <div className="contact-info-icon">
          <i className="fa fa-envelope"></i>
        </div>

        <div className="contact-info-content">

          <span>EMAIL</span>

          <a href="mailto:mathilakamofficespst@gmail.com">
            maildid@gmail.com
          </a>

         

        </div>

      </div>


      {/* Small bottom message */}
      <div className="contact-note">

        <i className="fa fa-info-circle"></i>

        <span>
          Please contact the office during official working hours
          for assistance.
        </span>

      </div>

    </div>


    {/* RIGHT - MAP */}
    <div className="contact-map">

      <iframe
        title="Azhimala Siva Temple"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d126289.88042140004!2d76.90826035795814!3d8.444915142195084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b05af55443fbb25%3A0x9174f2a75a0d46d5!2sAazhimala%20Shiva%20Temple!5e0!3m2!1sen!2sin!4v1790761374766!5m2!1sen!2sin"
        loading="lazy"
        allowFullScreen
      />

          


      {/* Map overlay */}
      <div className="map-location-card">

        <div className="map-location-icon">
          <i className="fa fa-map-marker"></i>
        </div>

        <div>
          <span>OUR LOCATION</span>
          <strong>Azhimala Siva Temple</strong>
          <small>Thiruvananthapuram, Kerala</small>
        </div>

      </div>


      {/* Directions */}
      <a
        href="https://www.google.com/maps/search/?api=1&query=Aazhimala+Shiva+Temple+Thiruvananthapuram"
        target="_blank"
        rel="noopener noreferrer"
        className="map-directions"
      >
        <i className="fa fa-location-arrow"></i>
        Get Directions
      </a>

    </div>

  </div>

</div>


      </div>
    </div>
  );
}

export default Contact;